import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

interface dropdownInterface {
  title: string;
  name: string;
  options: any;
  value: any;
  label: any;
  callback: (value: any, index: any) => void;
  index?: any;
  minWidth?: number;
  disabled?: boolean;
  defaultValue?: any;
  customStyles?: React.CSSProperties;
}
const Dropdown: React.FC<dropdownInterface> = ({
  title,
  name,
  options,
  value = "",
  label,
  callback,
  index = null,
  minWidth = 180,
  disabled,
  defaultValue,
  customStyles = {}
}) => {
  return (
    <div>
      <FormControl variant="standard" sx={{ m: "5px", minWidth: minWidth }}>
        <InputLabel id="demo-simple-select-standard-label">{title}</InputLabel>
        <Select
          labelId={`demo-${title}-simple-select-standard-label`}
          id={`demo-${title}-simple-select-standard`}
          name={name}
          value={value || ""}
          onChange={(e: any) => callback(e, index)}
          label={label}
          disabled={disabled}
          defaultValue={defaultValue}
          sx={{ ...customStyles }}
        >
          {options?.map((item: any) => {
            return <MenuItem value={item.value}>{item.name}</MenuItem>;
          })}
        </Select>
      </FormControl>
    </div>
  );
};

export default Dropdown;
